var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { PhoneNumberUtil } from 'libphonenumber';

var PRIMARY_PHONE_TYPE_MAP = {
    home: 'homeNumber',
    mobile: 'cellNumber',
    work: 'workNumber'
};

var RelatedAccountContacts = function () {
    function RelatedAccountContacts(InsuranceSuiteMetadata, $filter, ContactService) {
        _classCallCheck(this, RelatedAccountContacts);

        this._InsuranceSuiteMetadata = InsuranceSuiteMetadata;
        this._translateRole = function (name) {
            return $filter('translate')('gateway.contacts.common.views.roles.' + name);
        };
        this._contactsService = ContactService;
        this.selectedRelationship = null;
    }

    _createClass(RelatedAccountContacts, [{
        key: '$onChanges',
        value: function $onChanges(changesObj) {
            this.descriptionData = {
                accountNumber: this.accountNumber,
                accountName: this.accountName
            };
            if (changesObj.accountNumber) {
                this.resetQuery();
            }
        }
    }, {
        key: 'getPrimaryPhoneNumber',
        value: function getPrimaryPhoneNumber(contact) {
            var phoneNumber = contact[PRIMARY_PHONE_TYPE_MAP[contact.primaryPhoneType]];
            var phoneUtils = PhoneNumberUtil.getInstance();

            if (!phoneNumber) return null;
            try {
                return phoneUtils.format(phoneUtils.parse(phoneNumber, this._defaultLocaleDetails.countryCode));
            } catch (e) {
                return phoneNumber;
            }
        }
    }, {
        key: 'resetQuery',
        value: function resetQuery() {
            this.loadContacts(0, this.pageSize);
        }
    }, {
        key: 'setRelFilter',
        value: function setRelFilter(value) {
            if (this.selectedRelationship !== value) {
                this.selectedRelationship = value;
                this.resetQuery();
            }
        }
    }, {
        key: 'getRelationshipDescriptionKey',
        value: function getRelationshipDescriptionKey() {
            return this.relationshipKeysPrefix + '.' + (this.selectedRelationship || '$all');
        }
    }, {
        key: 'loadContacts',
        value: function loadContacts(toPage, pageSize) {
            var _this = this;

            if (!this.accountNumber) return;

            var currentPage = toPage;
            this.loaded = false;
            var queryPromise = void 0;
            if (this.selectedRelationship !== '$common') {
                var relationshipFilter = this.selectedRelationship ? [this.selectedRelationship] : [];
                queryPromise = this._contactsService.getRelatedAccountContacts(this.accountNumber, relationshipFilter, currentPage, pageSize);
            } else {
                queryPromise = this._contactsService.getCommonAccountContacts(this.accountNumber, currentPage, pageSize);
            }

            queryPromise.then(function (data) {
                _this.contacts = data.accountContacts;
                _this.firstContact = currentPage * pageSize;
                _this.currentPage = currentPage;
                _this.totalContacts = data.maxNumberOfResults;
                _this.loaded = true;
            });
        }
    }]);

    return RelatedAccountContacts;
}();

RelatedAccountContacts.$inject = ['InsuranceSuiteMetadata', '$filter', 'ContactService'];

export default RelatedAccountContacts;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/RelatedAccountContacts/RelatedAccountContacts.js
// module id = 1628
// module chunks = 0